export enum SourcePageKeyEnum {
    manufacturer = 'manufacturer',
    category = 'category',
    globalSearch = 'globalSearch',
}

